/**
 * OnFire Hockey — Scroll Reveal Animations
 *
 * Smooth transition-based reveals (no keyframe snap). Process:
 *   1. Collect all [data-animate] elements.
 *   2. For each, check if it's already in the viewport on load. If yes,
 *      tag with `is-initial` AND `is-visible` BEFORE `js-scroll-ready` is
 *      added — these elements never get hidden, so no flash.
 *   3. Add `js-scroll-ready` to <html>. Now remaining elements are hidden
 *      (opacity 0 + translateY). They transition to visible as they enter
 *      the viewport.
 *
 * Respects prefers-reduced-motion.
 */
(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  var elements = document.querySelectorAll('[data-animate]');
  if (!elements.length) return;

  var vh = window.innerHeight || document.documentElement.clientHeight;

  // Phase 1 — tag above-the-fold elements BEFORE hiding anything
  var toObserve = [];
  elements.forEach(function (el) {
    var rect = el.getBoundingClientRect();
    // Element is at least partially in view on load
    if (rect.top < vh && rect.bottom > 0) {
      el.classList.add('is-initial', 'is-visible');
    } else {
      toObserve.push(el);
    }
  });

  // Phase 2 — now hide the rest via js-scroll-ready class
  document.documentElement.classList.add('js-scroll-ready');

  if (!toObserve.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = el.getAttribute('data-animate-delay');
          if (delay) {
            el.style.transitionDelay = delay + 's';
          }
          el.classList.add('is-visible');
          observer.unobserve(el);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -80px 0px'
    }
  );

  toObserve.forEach(function (el) {
    observer.observe(el);
  });
})();
